import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Customer Recommended Files management moved into the Google Drive
 * integration page as a tab (see `_app/backoffice/integrations/google-drive/index.tsx`).
 * This route is kept as a redirect so old links/bookmarks still land in the
 * right place.
 */
export const Route = createFileRoute('/_app/recommended-files/')({
  beforeLoad: () => {
    throw redirect({
      to: '/backoffice/integrations/google-drive',
      search: { tab: 'recommended-files' },
    })
  },
})
